const STATUS = {
  PUBLISHED: 'published',
  DRAFT: 'draft',
  PENDING: 'pending_approval',
};

const BADGE_TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  ATTENTION: 'attention',
  WARNING: 'warning',
  NEW: 'new',
};

const BADGE_LABEL = {
  PUBLISHED: 'Published',
  DRAFT: 'Draft',
  PENDING: 'Pending approval',
  UNLISTED: 'Not listed',
  PRESELL: 'Preorder',
};

export { STATUS, BADGE_TYPE, BADGE_LABEL };
